import React from 'react';
import { motion } from "framer-motion";
import '../App.css';
import { services } from '../constants';
import ButtonLink from './ButtonLink';
import Footer from './Footer';

const ServiceCard = ({ service, index }) => (
  <motion.div 
    className='sm:w-[250px] w-full'
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.3 }}
    transition={{ duration: 0.5, delay: index * 0.1 }}
    whileHover={{ scale: 1.05, y: -10 }}
  >
    <div
      className='w-full green-pink-gradient p-[1px] rounded-[20px]'>
      <div
        className='rounded-[20px] py-5 px-12 min-h-[280px] flex justify-evenly items-center flex-col'
        style={{ background: '#151030' }}>
        <motion.img
          src={service.icon}
          alt='some_icon'
          className='object-contain w-16 h-16'
          whileHover={{ rotate: 360 }}
          transition={{ duration: 0.6 }}
        />
        <h3 className='text-white text-[20px] font-bold text-center'>
          {service.title}
        </h3>
      </div>
    </div>
  </motion.div>
);

const About = () => {
  return (
    <div>

      <div className='w-full h-full py-12 mt-8 overflow-x-hidden text-white bg-black sm:flex sm:justify-around about' id='about'>
        <div className='flex flex-col justify-around'>
          <motion.div 
            className='px-2 sm:px-16'
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6 }}
          >
            <motion.h2 
              className='mt-2 text-4xl font-extrabold sm:text-5xl'
              initial={{ opacity: 0, y: -20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              Introduction
            </motion.h2>
            <motion.p 
              className='mt-3 mb-6 text-[17px] max-w-3xl leading-[30px]'
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              👨‍💻 Hi, I'm Pranav, currently a student at K.R.Mangalam Univeristy. As a passionate and always learning <a className='text-green-300 duration-300 hover:text-green-500' href='https://www.linkedin.com/in/pranav-0b8820152/' target='_blank'>Software developer</a> I specialize in test automation and MERN stacks🚀.
              <br />
              On a different note, I'm also into photography📸. It's not just a hobby; I see it as a way to capture moments🌟, tell stories.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.4 }}
            >
              <ButtonLink
                url='https://drive.google.com/file/d/1EfYaE74YbU2DIRyir27gfO86-FBnzfrp/view?usp=sharing'
                text='View Resume →'
                padding={`p-3`}
              />
            </motion.div>

          </motion.div>
          <div className='flex flex-wrap justify-center mt-20 gap-7'>
            {services.map((service, index) => (
              <ServiceCard key={index} service={service} index={index} />
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default About;